import { InvoiceTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1900. 請求タスクファイル一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const invoiceTaskDocuments = (props: Props): Promise<InvoiceTaskDocument[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_documents`
  );
};

export const useInvoiceTaskDocuments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => invoiceTaskDocuments(props)
  });
};

export const useInvoiceTaskDocumentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'invoice_tasks',
    props.task_id,
    'invoice_task_documents',
  ];
};
